// Client-side mirror of backend/event_lifecycle.py — used only for
// disabling inputs / showing the "event started" banner. Backend
// remains authoritative.
export const ACTUAL_STARTED_STATUSES = new Set(['in_progress', 'completed', 'archived']);
export function isEventStarted(status) {
  return ACTUAL_STARTED_STATUSES.has(status);
}
